<template>
  <b-container class="center-content-container" :class="{ 'height100vh': !maxHeight }">
    <div class="iq-card modern-select-app-card" :class="{ 'desktop-app-card': !maxWidth }">
      <div class="iq-card-header">
        <div v-if="!hideHeader" class="iq-header-title w-100">
          <div class="py-3 text-center">
            <h4 class="card-title mb-2">Select Application</h4>
            <h6 class="text-center text-muted">Please select your application to proceed.</h6>
          </div>
        </div>
      </div>
      <div class="iq-card-body">
        <div class="modern-select-app-wrapper">
          <button v-for="app in apps" :key="app.name" class="app-card" :class="{
            'app-card-active': selectedApp === app.name && !app.disabled,
            'app-card-disabled': app.disabled
          }" @click="app.disabled ? null : onSelectApp(app.name)" :disabled="app.disabled">
            <div class="app-card-content">
              <div class="modern-app-icon" v-html="app.svgIcon"></div>
              <div class="app-card-text">
                <span class="modern-app-label">{{ app.label }}</span>
                <span v-if="!app.disabled && selectedApp === app.name" class="app-status active-app">Active</span>
              </div>
            </div>
          </button>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="pull-right mt-4">
              <button @click="onConfirmSelection" :disabled="!selectedApp || isLoading"
                class="btn btn-primary modern-confirm-button">
                <i v-if="isLoading" class="ri-loader-line mr-2"></i>
                Confirm Selection
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'AppActiveSelection',
  props: ['maxWidth', 'hideHeader', 'maxHeight'],
  components: {
  },
  computed: {
  },
  async created() {
    // GPS Viewer cuma boleh akses Fuel Monitoring System - skip picker, auto-confirm.
    if (this.$store.getters['auth/isGpsViewer']) {
      this.selectedApp = 'fms';
      await this.onConfirmSelection();
      return;
    }
    this.selectedApp = this.$store.state?.auth?.activeApp?.name;
  },
  data() {
    return {
      apps: [
        {
          name: 'fms',
          label: 'Fuel Monitoring System',
          routeName: 'Home',
          svgIcon: '<svg fill="currentcolor" width="64px" height="64px" viewBox="0 0 64 64" id="Layer_1_1_" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M38.303,25.015C38.761,23.365,39,21.684,39,20C39,9.523,30.477,1,20,1S1,9.523,1,20c0,10.373,8.359,18.819,18.694,18.984 C19.254,40.585,19,42.262,19,44c0,10.477,8.523,19,19,19s19-8.523,19-19C57,33.626,48.639,25.18,38.303,25.015z M20,37 c-9.374,0-17-7.626-17-17S10.626,3,20,3s17,7.626,17,17c0,1.711-0.283,3.419-0.813,5.092c-0.756,0.072-1.497,0.192-2.225,0.35 C34.64,23.708,35,21.862,35,20c0-8.271-6.729-15-15-15S5,11.729,5,20c0,3.601,1.307,7.089,3.679,9.821l1.51-1.311 C8.354,26.396,7.26,23.76,7.045,21H11v-2H7.051c0.054-0.701,0.165-1.385,0.326-2.05l3.755,1.22l0.617-1.902l-3.763-1.222 c0.267-0.644,0.592-1.256,0.954-1.844l3.19,2.317l1.176-1.617l-3.194-2.32c0.45-0.528,0.941-1.018,1.468-1.468l2.32,3.194 l1.617-1.176l-2.317-3.19c0.587-0.363,1.2-0.688,1.844-0.954l1.222,3.763l1.902-0.617l-1.22-3.755 c0.666-0.161,1.349-0.272,2.05-0.326V11h2V7.051c0.701,0.054,1.385,0.165,2.05,0.326l-1.22,3.755l1.902,0.617l1.222-3.763 c0.644,0.267,1.256,0.592,1.844,0.954l-2.317,3.19l1.617,1.176l2.32-3.194c0.528,0.45,1.018,0.941,1.468,1.468l-3.194,2.32 l1.176,1.617l3.19-2.317c0.363,0.587,0.688,1.2,0.954,1.844l-3.763,1.222l0.617,1.902l3.755-1.22 c0.161,0.666,0.272,1.349,0.326,2.05H29v2h3.957c-0.142,1.816-0.673,3.592-1.554,5.205c-3.463,1.288-6.445,3.552-8.619,6.465 C21.841,32.879,20.904,33,20,33c-3.119,0-6.142-1.133-8.511-3.188l-1.311,1.51C12.911,33.693,16.399,35,20,35 c0.433,0,0.876-0.042,1.317-0.083c-0.363,0.664-0.675,1.358-0.958,2.067C20.24,36.99,20.121,37,20,37z M38,61 c-9.374,0-17-7.626-17-17s7.626-17,17-17s17,7.626,17,17S47.374,61,38,61z"></path> <path d="M38,29c-8.271,0-15,6.729-15,15v1h8v-1c0-3.859,3.141-7,7-7c1.799,0,3.436,0.688,4.677,1.807l-4.732,14.198 C36.317,53.036,35,54.365,35,56c0,1.654,1.346,3,3,3s3-1.346,3-3c0-0.958-0.46-1.804-1.162-2.353L44.16,40.68 C44.695,41.669,45,42.799,45,44v1h8v-1C53,35.729,46.271,29,38,29z M38,57c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1 S38.552,57,38,57z M46.944,43c-0.197-1.772-0.916-3.386-1.992-4.697l0.996-2.987l-1.896-0.633l-0.697,2.09 C41.858,35.661,40.005,35,38,35c-4.625,0-8.445,3.506-8.944,8h-4.018c0.513-6.703,6.13-12,12.962-12s12.449,5.297,12.962,12H46.944 z"></path> <path d="M55,5h-8v6h8V5z M53,9h-4V7h4V9z"></path> <path d="M62.121,7.707L59,4.586V4c0-1.654-1.346-3-3-3H46c-1.654,0-3,1.346-3,3v13.184c-1.161,0.414-2,1.514-2,2.816v3h20v-3 c0-1.302-0.839-2.402-2-2.816V16h1c1.654,0,3-1.346,3-3V9.828C63,9.027,62.688,8.273,62.121,7.707z M46,3h10c0.552,0,1,0.448,1,1 v13H45V4C45,3.448,45.448,3,46,3z M59,21H43v-1c0-0.552,0.448-1,1-1h14c0.552,0,1,0.448,1,1V21z M61,13c0,0.552-0.448,1-1,1h-1 V7.414l1.707,1.707C60.894,9.308,61,9.565,61,9.828V13z"></path> <path d="M20,31c1.654,0,3-1.346,3-3c0-1.302-0.839-2.402-2-2.816V15h-2v10.184c-1.161,0.414-2,1.514-2,2.816 C17,29.654,18.346,31,20,31z M20,27c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S19.448,27,20,27z"></path> </g> </g></svg>',
          disabled: false,
        },
        {
          name: 'bunkering',
          label: 'Bunkering Monitoring',
          routeName: 'BunkerDashboard',
          svgIcon: '<svg fill="currentcolor" height="64px" width="64px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g transform="translate(1 1)"> <g> <g> <path d="M335.213,340.333h-125.44c-17.067,0-30.72,14.507-30.72,31.573v23.04c0,17.067,13.653,30.72,30.72,30.72h125.44 c17.067,0,30.72-13.653,31.573-30.72v-23.04C366.787,353.987,352.28,340.333,335.213,340.333z M335.213,408.6h-125.44 c-7.68,0-13.653-5.973-13.653-13.653v-3.413h25.6c4.267,0,7.68-3.413,7.68-8.533s-2.56-8.533-7.68-8.533h-25.6v-2.56 c0-8.533,5.973-14.507,13.653-14.507h125.44c8.533,0,14.507,6.827,14.507,14.507v2.56h-26.453c-5.12,0-8.533,3.413-8.533,8.533 s3.413,8.533,8.533,8.533h26.453v3.413C349.72,402.627,342.893,408.6,335.213,408.6z"></path> <path d="M502.467,408.6h-102.4v-51.2h102.4c5.12,0,8.533-3.413,8.533-8.533c0-5.12-3.413-8.533-8.533-8.533h-102.4v-2.56 c0-17.067-13.653-30.72-30.72-30.72H313.88V263.96C354.486,247.508,383,207.765,383,161.133 C383,99.693,333.507,50.2,272.067,50.2S161.133,99.693,161.133,161.133c0,46.305,28.115,85.819,68.267,102.479v43.441h-53.76 c-17.92,0-31.573,13.653-31.573,30.72v3.71c-33.555-4.235-59.733-33.054-59.733-67.71V58.733c0-5.12-3.413-8.533-8.533-8.533 s-8.533,3.413-8.533,8.533v215.04c0,44.373,34.133,81.067,76.8,85.333V408.6c-70.827-4.267-128-63.147-128-134.827V58.733 c0-5.12-3.413-8.533-8.533-8.533S-1,53.613-1,58.733v215.04c0,80.792,64.516,147.241,145.067,151.653v2.8 c0,17.92,14.507,31.573,31.573,31.573h193.707c17.067,0,30.72-13.653,30.72-30.72v-3.413h102.4c5.12,0,8.533-3.413,8.533-8.533 C511,412.013,507.587,408.6,502.467,408.6z M297.667,306.2h-51.2v-37.08c0.568,0.134,1.141,0.254,1.712,0.379 c0.632,0.138,1.264,0.274,1.899,0.401c0.624,0.125,1.249,0.244,1.876,0.358c0.568,0.103,1.139,0.198,1.71,0.293 c0.928,0.154,1.86,0.296,2.795,0.427c0.656,0.092,1.312,0.181,1.971,0.261c0.557,0.068,1.116,0.131,1.675,0.19 c0.886,0.094,1.776,0.177,2.669,0.251c0.439,0.036,0.879,0.071,1.319,0.102c1.032,0.073,2.068,0.13,3.108,0.174 c0.367,0.016,0.734,0.03,1.101,0.042c1.25,0.041,2.503,0.07,3.763,0.07c1.264,0,2.521-0.029,3.774-0.07 c0.356-0.012,0.712-0.025,1.067-0.04c1.121-0.048,2.238-0.108,3.35-0.189c0.248-0.018,0.496-0.037,0.744-0.056 c1.1-0.087,2.194-0.193,3.284-0.312c0.356-0.039,0.711-0.079,1.066-0.121c4.182-0.495,8.292-1.219,12.316-2.163V306.2z M303.159,249.772c-0.124,0.037-0.248,0.067-0.372,0.108c-10.187,3.396-20.585,5.099-30.984,5.117 c-0.282-0.001-0.562-0.007-0.843-0.011c-0.643-0.005-1.287-0.022-1.93-0.039c-15.628-0.491-30.26-4.754-43.024-11.916 c11.094-14.492,28.151-22.164,46.062-22.164c17.91,0,34.968,7.673,46.062,22.164 C313.382,245.694,308.377,247.955,303.159,249.772z M178.2,161.133c0-52.053,42.667-93.867,93.867-93.867 c52.053,0,93.867,41.813,93.867,93.867c0,28.978-12.963,54.778-33.433,71.962c-14.824-18.531-36.953-29.295-60.434-29.295 c-23.333,0-45.334,10.628-60.155,29.53C191.28,216.147,178.2,190.243,178.2,161.133z M383,428.227 c0,8.533-5.973,14.507-13.653,14.507H175.64c-8.533,0-14.507-6.827-14.507-14.507v-11.093v-66.56V336.92 c0-13.653,14.507-12.8,14.507-12.8h193.707c7.68,0,13.653,5.973,13.653,13.653v11.093v68.267V428.227z"></path> <path d="M212.333,161.133c0-4.267-3.413-8.533-8.533-8.533c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533 C208.92,169.667,212.333,166.253,212.333,161.133z"></path> <path d="M340.333,169.667c5.12,0,8.533-3.413,8.533-8.533c0-4.267-3.413-8.533-8.533-8.533c-5.12,0-8.533,3.413-8.533,8.533 S335.213,169.667,340.333,169.667z"></path> <path d="M220.867,127c5.12,0,8.533-3.413,8.533-8.533c0-4.267-3.413-8.533-8.533-8.533s-8.533,3.413-8.533,8.533 S215.747,127,220.867,127z"></path> <path d="M272.067,101.4c5.12,0,8.533-3.413,8.533-8.533c0-4.267-3.413-8.533-8.533-8.533c-5.12,0-8.533,3.413-8.533,8.533 S266.947,101.4,272.067,101.4z"></path> <path d="M323.267,127c5.12,0,8.533-3.413,8.533-8.533c0-4.267-3.413-8.533-8.533-8.533s-8.533,3.413-8.533,8.533 S318.147,127,323.267,127z"></path> <path d="M265.24,183.32c1.707,2.56,7.68,3.413,11.093,0.853s4.267-8.533,0.853-11.947l-28.16-34.133 c-2.56-3.413-8.533-4.267-11.947-0.853c-3.413,2.56-4.267,8.533-0.853,11.947L265.24,183.32z"></path> </g> </g> </g> </g></svg> ',
          disabled: false,
        },
        {
          name: 'engine_health',
          label: 'Engine Health Monitoring',
          routeName: null,
          svgIcon: '<svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 16H12.01M12 11V13M14 8V5M11 5H17M6 12H3M3 9V15M21 11V19M6 8V16H8L10 19H18V10L16 8H6Z" stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>',
          disabled: true,
        },
        {
          name: 'alert_system',
          label: 'Alert System',
          routeName: null,
          svgIcon: '<svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracurrentcolorerCarrier" stroke-linecurrentcolorap="round" stroke-linejoin="round"></g><g id="SVGRepo_icurrentcoloronCarrier"> <path fill-rule="evenodd" currentcolorlip-rule="evenodd" d="M11.5 0.999992C10.9477 0.999992 10.5 1.44771 10.5 1.99999V2.99999H9.99998C7.23864 2.99999 4.99998 5.23824 4.99998 7.99975V11C4.99998 11.7377 4.76718 12.5722 4.39739 13.4148C4.03164 14.2482 3.55875 15.0294 3.14142 15.6439C2.38188 16.7624 2.85215 18.5301 4.40564 18.8103C5.42144 18.9935 6.85701 19.2115 8.54656 19.3527C8.54454 19.4015 8.54352 19.4506 8.54352 19.5C8.54352 21.433 10.1105 23 12.0435 23C13.9765 23 15.5435 21.433 15.5435 19.5C15.5435 19.4482 15.5424 19.3966 15.5402 19.3453C17.1921 19.204 18.596 18.9903 19.5943 18.8103C21.1478 18.5301 21.6181 16.7624 20.8586 15.6439C20.4412 15.0294 19.9683 14.2482 19.6026 13.4148C19.2328 12.5722 19 11.7377 19 11V7.99975C19 5.23824 16.7613 2.99999 14 2.99999H13.5V1.99999C13.5 1.44771 13.0523 0.999992 12.5 0.999992H11.5ZM12 19.5C12.5113 19.5 13.0122 19.4898 13.4997 19.4715C13.5076 20.2758 12.8541 20.9565 12.0435 20.9565C11.2347 20.9565 10.5803 20.2778 10.5872 19.4746C11.0473 19.491 11.5191 19.5 12 19.5ZM9.99998 4.99999C8.34305 4.99999 6.99998 6.34297 6.99998 7.99975V11C6.99998 12.1234 6.65547 13.2463 6.22878 14.2186C5.79804 15.2 5.25528 16.0911 4.79599 16.7675C4.78578 16.7825 4.78102 16.7969 4.77941 16.8113C4.77797 16.8242 4.77919 16.8362 4.78167 16.8458C6.3644 17.1303 9.00044 17.5 12 17.5C14.9995 17.5 17.6356 17.1303 19.2183 16.8458C19.2208 16.8362 19.222 16.8242 19.2206 16.8113C19.2189 16.7969 19.2142 16.7825 19.204 16.7675C18.7447 16.0911 18.2019 15.2 17.7712 14.2186C17.3445 13.2463 17 12.1234 17 11V7.99975C17 6.34297 15.6569 4.99999 14 4.99999H9.99998Z" fill="currentcolor"></path> <path fill-rule="evenodd" currentcolorlip-rule="evenodd" d="M16.0299 0.757457C16.1622 0.228068 16.7146 -0.102469 17.2437 0.0301341C17.3131 0.0476089 17.3789 0.0669732 17.4916 0.104886C17.6295 0.151258 17.8183 0.221479 18.0424 0.322098C18.4894 0.522794 19.0851 0.848127 19.6982 1.35306C20.9431 2.37831 22.2161 4.1113 22.495 6.9005C22.55 7.45005 22.149 7.94009 21.5995 7.99504C21.05 8.05 20.5599 7.64905 20.505 7.09951C20.2839 4.88869 19.3068 3.62168 18.4268 2.89692C17.9774 2.52686 17.5418 2.28969 17.2232 2.14664C17.0645 2.07538 16.9369 2.02841 16.8541 2.00057C16.8201 1.98913 16.7859 1.97833 16.7513 1.96858C16.2192 1.83203 15.8964 1.2912 16.0299 0.757457Z" fill="currentcolor"></path> <path fill-rule="evenodd" currentcolorlip-rule="evenodd" d="M7.97014 0.757457C7.83619 0.221662 7.29326 -0.104099 6.75746 0.0298498C6.68765 0.0473468 6.62176 0.066766 6.5084 0.104885C6.37051 0.151257 6.1817 0.221478 5.9576 0.322097C5.51059 0.522793 4.91493 0.848125 4.30179 1.35306C3.05685 2.37831 1.78388 4.1113 1.50496 6.90049C1.45001 7.45003 1.85095 7.94008 2.40049 7.99503C2.95004 8.04998 3.44008 7.64904 3.49504 7.0995C3.71612 4.88869 4.69315 3.62168 5.57321 2.89692C6.02257 2.52686 6.45815 2.28969 6.77678 2.14664C6.93548 2.07538 7.06308 2.02841 7.14589 2.00057C7.17991 1.98913 7.21413 1.97833 7.24867 1.96858C7.78081 1.83203 8.10358 1.2912 7.97014 0.757457Z" fill="currentcolor"></path> </g></svg>',
          disabled: true,
        },
        {
          name: 'plan_management',
          label: 'Plan Management System',
          routeName: null,
          svgIcon: '<svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M6 21C7.5 19.4 9 17.9673 9 16.2C9 14.4327 7.65685 13 6 13C4.34315 13 3 14.4327 3 16.2C3 17.9673 4.5 19.4 6 21ZM6 21H17.5C18.8807 21 20 19.8807 20 18.5C20 17.1193 18.8807 16 17.5 16H15M18 11C19.5 9.4 21 7.96731 21 6.2C21 4.43269 19.6569 3 18 3C16.3431 3 15 4.43269 15 6.2C15 7.96731 16.5 9.4 18 11ZM18 11H14.5C13.1193 11 12 12.1193 12 13.5C12 14.8807 13.1193 16 14.5 16H15.6" stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>',
          disabled: true,
        },
        {
          name: 'tank_level_monitoring',
          label: 'Tank Level Monitoring',
          routeName: null,
          svgIcon: '<svg fill="currentcolor" height="64px" width="64px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M450.626,460.026h-9.4V51.974h9.4c14.329,0,25.987-11.658,25.987-25.987C476.613,11.658,464.956,0,450.626,0H61.374 C47.044,0,35.387,11.658,35.387,25.987c0,14.329,11.658,25.987,25.987,25.987h9.4v133.253c0,4.581,3.712,8.294,8.294,8.294 s8.294-3.712,8.294-8.294v-27.093h89.019c4.581,0,8.294-3.712,8.294-8.294c0-4.581-3.712-8.294-8.294-8.294H87.361V51.974h337.279 v89.572H335.62c-4.581,0-8.294,3.712-8.294,8.294c0,4.581,3.712,8.294,8.294,8.294h89.019v195.732h-80.173 c-4.581,0-8.294,3.712-8.294,8.294c0,4.581,3.712,8.294,8.294,8.294h80.173v89.572H87.361v-89.572h89.019 c4.581,0,8.294-3.712,8.294-8.294c0-4.581-3.712-8.294-8.294-8.294H87.361v-133.25c0-4.581-3.712-8.294-8.294-8.294 s-8.294,3.712-8.294,8.294v239.41h-9.4c-14.329,0-25.987,11.658-25.987,25.987c0,14.329,11.658,25.987,25.987,25.987h389.253 c14.329,0,25.987-11.658,25.987-25.987C476.613,471.684,464.956,460.026,450.626,460.026z M61.374,35.387 c-5.183,0-9.4-4.217-9.4-9.4c0-5.183,4.217-9.4,9.4-9.4h389.253c5.183,0,9.4,4.217,9.4,9.4c0,5.183-4.216,9.4-9.4,9.4H61.374z M450.626,495.413H61.374c-5.183,0-9.4-4.217-9.4-9.4s4.217-9.4,9.4-9.4h389.253c5.183,0,9.4,4.216,9.4,9.4 S455.809,495.413,450.626,495.413z"></path> </g> </g> <g> <g> <path d="M302.713,190.68c-19.898-29.881-39.464-53.92-40.288-54.929c-3.266-4.005-9.585-4.005-12.851,0 c-0.824,1.008-20.389,25.048-40.288,54.929c-27.338,41.053-41.2,71.959-41.2,91.86c0,48.476,39.437,87.914,87.914,87.914 s87.914-39.437,87.914-87.914C343.914,262.638,330.052,231.732,302.713,190.68z M256,353.866 c-39.329,0-71.326-31.997-71.326-71.326c0-30.678,46.713-96.76,71.327-128.244c24.615,31.476,71.325,97.545,71.325,128.244 C327.326,321.869,295.329,353.866,256,353.866z"></path> </g> </g> <g> <g> <path d="M297.564,316.536c-3.055-3.409-8.299-3.699-11.712-0.642c-8.226,7.373-18.828,11.432-29.852,11.432 c-4.581,0-8.294,3.712-8.294,8.294s3.712,8.294,8.294,8.294c15.116,0,29.648-5.563,40.921-15.665 C300.333,325.191,300.62,319.947,297.564,316.536z"></path> </g> </g> <g> <g> <path d="M280.85,205.731c-2.536-3.813-7.682-4.85-11.498-2.313c-3.814,2.536-4.85,7.684-2.313,11.498 c33.364,50.176,33.748,66.935,33.748,67.624c0,5.119-0.859,10.139-2.556,14.923c-1.431,4.035,0.551,8.634,4.472,10.359 c4.359,1.918,9.574-0.335,11.163-4.819c2.328-6.568,3.508-13.452,3.508-20.463C317.374,275.96,313.814,255.304,280.85,205.731z"></path> </g> </g> </g></svg>',
          disabled: true,
        },
      ],
      isLoading: false,
      selectedApp: undefined,
    };
  },
  methods: {
    async onConfirmSelection() {
      if (!this.selectedApp) return;

      const selected = this.apps.find((app) => app.name === this.selectedApp);
      if (selected && selected.disabled) {
        return;
      }

      this.isLoading = true;
      try {
        await this.$store.dispatch('auth/changeActiveApp', selected);
        this.$router.push({ name: selected.routeName });
        this.$bvModal.hide('select-app-modal');
      } catch (error) {
        console.error('Error confirming selection:', error);
      } finally {
        this.isLoading = false;
      }
    },
    onSelectApp(company) {
      const app = this.apps.find((a) => a.name === company);
      if (app && !app.disabled) {
        this.selectedApp = company;
      }
    },
  },
};
</script>

<style scoped>
/* Reset & Basic Typography */
body {
  font-family: 'Inter', sans-serif;
  background-color: #f8f9fa;
  /* Light grey background for the page */
}

/* Container untuk centering */
.center-content-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.height100vh {
  min-height: 100vh;
}

/* Card General */
.modern-select-app-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: 100%;
  max-width: 550px;
  /* Lebar disesuaikan untuk 2 kolom */
  margin: auto;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  background-color: white;
  overflow: hidden;
  padding: 20px;
  /* Add padding to the main card */
}

.iq-card-header {
  padding-bottom: 0;
}

.iq-header-title {
  padding: 15px 0;
}

.card-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #343a40;
  /* Dark grey */
  text-align: center;
  margin-bottom: 5px;
}

.text-muted {
  color: #6c757d !important;
  /* Medium grey */
  font-size: 0.9rem;
  text-align: center;
}

.iq-card-body {
  padding: 0;
  /* Remove default card body padding */
}

/* App Selection Wrapper (Grid) */
.modern-select-app-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  /* Diubah menjadi 2 kolom */
  gap: 15px;
  margin-top: 20px;
  padding: 15px;
}

/* App Card Styling */
.app-card {
  display: flex;
  align-items: center;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: white;
  cursor: pointer;
  transition: border-color 0.3s ease;
  text-align: left;
  /* Align text to the left */
  position: relative;
  /* For coming soon badge positioning */
}

.app-card:hover {
  border-color: #adb5bd;
  /* Slightly darker grey on hover */
}

.app-card-active {
  background: linear-gradient(to right, #ff69b4, #ff3d9a);
  /* Pink to purple gradient */
  color: white;
  border-color: transparent;
}

.app-card-active:hover {
  border-color: transparent;
  /* Keep border transparent on hover for active */
}

.app-card-disabled {
  background-color: #f8f9fa;
  /* Light grey */
  color: #6c757d;
  /* Medium grey */
  border-color: #e0e0e0;
  cursor: not-allowed;
  opacity: 0.8;
}

.app-card-disabled:hover {
  border-color: #e0e0e0;
}

.app-card-content {
  display: flex;
  align-items: center;
  width: 100%;
}

.modern-app-icon {
  width: 45px;
  height: 45px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modern-app-icon svg {
  width: 100%;
  height: 100%;
  fill: #6c757d;
  /* Default icon color */
  stroke: none;
}

.app-card:hover .modern-app-icon svg,
.app-card-disabled .modern-app-icon svg {
  fill: #495057;
  /* Darker grey on hover/disabled */
}

.app-card-active .modern-app-icon svg {
  fill: white;
  /* White icon when active */
}

.app-card-text {
  flex-grow: 1;
}

.modern-app-label {
  font-weight: 500;
  font-size: 1rem;
  display: block;
}

.app-status {
  font-size: 0.8rem;
  color: #6c757d;
  display: block;
  margin-top: 2px;
}

.app-card-active .app-status {
  color: rgba(255, 255, 255, 0.8);
  /* Light text for active status */
}

/* Coming Soon Badge */
.coming-soon-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: #6c757d;
  /* Medium grey */
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 500;
  text-transform: uppercase;
}

/* Confirm Button */
.modern-confirm-button {
  background: linear-gradient(to right, #ff69b4, #ff3d9a);
  /* Pink to purple gradient */
  border: none;
  color: white;
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 8px;
  transition: background-color 0.3s ease;
  margin-top: 20px;
  width: 100%;
  /* Make button full width */
}

.modern-confirm-button:hover {
  opacity: 0.9;
}

.modern-confirm-button:disabled {
  background: #cccccc;
  cursor: not-allowed;
}

/* Loading Spinner */
.ri-loader-line {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .modern-select-app-wrapper {
    grid-template-columns: 1fr;
    /* Kembali ke 1 kolom di layar kecil */
  }

  .modern-select-app-card {
    max-width: 95%;
  }
}
</style>
